<div #visualObjectContainer>
  <floating [floatingPosition]="panel.floatingPosition">
    <div class="visual-object-margin header-panel" [style.max-width]="width" >
      <span class="{{classes}}">{{panel.title}}</span>
      <hr />
    </div>
  </floating>
</div>